import axios from '@/libs/api.request'
import config from '@/config'

// 数据库管理基础URL
const dbBaseUrl = `${config.baseDBUrl}/database/api/v1/`

export const getSearchList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/instance/search/',
    params: params,
    method: 'get',
    paramsSerializer: function (params) {
      return require('qs').stringify(params, { indices: false })
    }
  })
}

export const deleteSearch = (id) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/instance/search' + id + '/',
    method: 'delete'
  })
}

export const createSearch = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/instance/search/',
    method: 'post',
    data: data
  })
}

export const updateSearch = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/instance/search/' + data.id + '/',
    method: 'put',
    data: data
  })
}

export const showDatabases = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/instance/search/show/',
    method: 'get',
    params: params
  })
}

export const processlist = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/instance/search/processlist/',
    method: 'get',
    params: params
  })
}

export const getExecuteLog = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/instance/search/execute/log/',
    params: params,
    method: 'get'
  })
}

export const createExecuteLog = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/instance/search/execute/log/',
    data: data,
    method: 'post'
  })
}

export const showEventList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/instance/search/event/show/',
    params: params,
    method: 'get'
  })
}

export const getEventData = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/instance/search/event/get/',
    params: params,
    method: 'get'
  })
}

export const createEvent = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/instance/search/event/create/',
    data: data,
    method: 'post'
  })
}

export const alterEvent = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/instance/search/event/alter/',
    data: data,
    method: 'post'
  })
}

export const executeSQL = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/instance/search/sql/execute/',
    data: data,
    method: 'POST'
  })
}

export const showViewList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/instance/search/view/show/',
    params: params,
    method: 'get'
  })
}

export const showTableList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/instance/search/table/show/',
    params: params,
    method: 'get'
  })
}

export const showFuncList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/instance/search/routine/show/',
    params: params,
    method: 'get'
  })
}

export const showColumnList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/instance/search/column/show/',
    params: params,
    method: 'get'
  })
}

export const showCharacterList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/instance/search/character/show/',
    params: params,
    method: 'get'
  })
}

export const showCharacterCollateList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/instance/search/character/collate/show/',
    params: params,
    method: 'get'
  })
}

export const getViewData = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/instance/search/view/get/',
    params: params,
    method: 'get'
  })
}

export const getTableInfo = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/instance/search/table/info/',
    data: data,
    method: 'POST'
  })
}

export const getFuncData = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/instance/search/routine/get/',
    params: params,
    method: 'get'
  })
}

export const getCommonSQL = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/common/sql/',
    params: params,
    method: 'get'
  })
}

export const getColumnList = (params) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/instance/search/column/get/',
    params: params,
    method: 'get'
  })
}

export const explainSQL = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/instance/search/mysql/sql/explain/',
    data: data,
    method: 'post'
  })
}

export const createView = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/view/create/',
    data: data,
    method: 'post'
  })
}

export const createTable = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/table/create/',
    data: data,
    method: 'post'
  })
}

export const createFunc = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/routine/create/',
    data: data,
    method: 'post'
  })
}

export const alterView = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/view/alter/',
    data: data,
    method: 'post'
  })
}

export const alterFunc = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/routine/alter/',
    data: data,
    method: 'post'
  })
}

export const alertTable = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/table/alter/',
    data: data,
    method: 'post'
  })
}

export const killProcessBySql = (data) => {
  return axios.request({
    url: dbBaseUrl + 'mysql/instance/search/kill_process_by_sql/',
    data: data,
    method: 'POST'
  })
}
